(function () {
  var burger = document.querySelector('.lc-nav__burger');
  var drawer = document.getElementById('lc-mobile-drawer');
  if (!burger || !drawer) return;

  var closeTriggers = drawer.querySelectorAll('[data-lc-drawer-close]');
  var links = drawer.querySelectorAll('.lc-drawer__link, .lc-drawer__search, .lc-drawer__cart');

  function open() {
    drawer.classList.add('lc-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    burger.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('lc-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    burger.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    if (drawer.classList.contains('lc-drawer--open')) {
      close();
    } else {
      open();
    }
  });

  closeTriggers.forEach(function (el) {
    el.addEventListener('click', close);
  });

  links.forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth >= 750) close();
  });
})();
